import { useTranslation } from 'next-i18next'

import GradeList from '~/curriculum/components/GradeList'
import SelectToggle, { Tab } from '~/curriculum/components/SelectToggle'
import ROUTES from '~/shared/constants/routes.const'
import { DefaultLayout } from '~/shared/layouts'
import useGetGradePageRoute from '~/dashboard/hooks/useGetGradePageRoute'
import useRedirectV2UserToGradeOverview from '~/curriculum/hooks/useRedirectV2UserToGradeOverview'
import CurriculumSelection from '~/curriculum/components/CurriculumSelection'
import { useGetShowNorwegianCurriculumLanguageText } from '~/curriculum/hooks/useGetCurriculumCountryCode'
import { CurriculumSelectionPoints } from '~/curriculum/constants/curriculum.const'

interface GradeProps {
  defaultTab: Tab
}

export default function SelectGradePage({ defaultTab }: GradeProps): React.ReactElement {
  // Redirect Curriculum v2 users off the v1 bootcamp select-grade page to the v2 select-grade.
  useRedirectV2UserToGradeOverview()

  const { t } = useTranslation(['onboarding', 'curriculum'])
  const gradeUrl = useGetGradePageRoute()
  const showNorwegianCurriculumLanguageText = useGetShowNorwegianCurriculumLanguageText()

  return (
    <DefaultLayout>
      <div className="lg:relative -mt-6">
        <SelectToggle defaultTab={defaultTab} gradeUrl={gradeUrl} topicUrl={ROUTES.BOOTCAMP} />
        <div className="lg:absolute lg:right-0 lg:top-0">
          <CurriculumSelection selectionPoint={CurriculumSelectionPoints.SELECT_GRADE} />
        </div>
      </div>
      {showNorwegianCurriculumLanguageText && (
        <h2 className="text-white text-3 mt-2 -mb-2 tracking-px leading-8 text-center">
          {t('curriculum:norwegianAvailability')}
        </h2>
      )}
      <span className="flex justify-center font-semibold text-center text-h3 md:text-4xl my-6 text-white drop-shadow-lg tracking-wider">
        {t('onboarding:curriculum.selectYourGrade')}
      </span>
      <GradeList />
    </DefaultLayout>
  )
}
